export default "__VITE_ASSET__Ar3aYpyYj2aPFA5cGwTEqg__"